import { SkeletonDisplayText, SkeletonDisplayTextProps } from '@shopify/polaris';
import { SkeletonCustomStyled } from './styled';

export interface SkeletonCustomProps extends SkeletonDisplayTextProps {
  height?: string;
  opacity?: boolean;
  minWidth?: string;
}
const SkeletonCustom = (props: SkeletonCustomProps) => {
  return (
    <SkeletonCustomStyled opacity={props.opacity} height={props.height} minWidth={props.minWidth}>
      <SkeletonDisplayText {...props}></SkeletonDisplayText>
    </SkeletonCustomStyled>
  );
};

export default SkeletonCustom;
